import React from 'react';
import '../../App.css';
import Navbar from '../Navbar';

export default function About() {
  return (
    <>
      <Navbar />
      <div className='about-container'>
        <div>
          <div className='about-section'>
          <div>&nbsp;</div>
          <div>&nbsp;</div>
            <h2>About Me</h2>
            <div>&nbsp;</div>
            <p>
              Hi there! My name is Dipesh Dhakal and I am a passionate iOS developer and I live in the beautiful city called Sydney. I have been coding for 9+ and I love creating beautiful and functional mobile applications.
            </p>
            <p>
              I have expertise on building iOS applications using Swift and SwiftUI from start to release. To me software development is not just about writing code, it's about creating an experience that users will love. I am always striving to build applications that are not only visually appealing but also intuitive and user-friendly. I am also obssed about automation which is ironic because I hate AI, probably because of the fear that it might take my job one day.
              I have experience working with various APIs, databases, and third-party libraries to create seamless user experiences. I am also familiar with the latest iOS development trends and best practices.
            </p>
            <p>
              In my free time, I like to explore new technologies and expand my knowledge in the field of iOS development. I am always excited to take on new challenges and learn new things.
            </p>
            <p>
              If you have any questions or would like to collaborate on a project, feel free to reach out to me. I would love to hear from you!
            </p>
          </div>
          <div>&nbsp;</div>
          <div className='about-section'>
            <p>
              Outside of writing software, I am pretty boring. I am introverted and I like to spend most of my time coding. I am the kind of guy who is more excited for WWDC event than next marvel movie .I am a huge fan of open-source software and I contribute to various projects in my free time.
              Apart from coding, I also have a few hobbies that I enjoy in my free time. One of my favorite hobbies is playing soccer. I find it not only a great way to stay active but also a fun way to connect with other people.
            </p>
            <p>
              Another hobby of mine is watching movies. I love exploring different genres and discovering new films. It's a great way for me to relax and unwind after a long day of coding.
            </p>
            <p>
              Lastly, I also enjoy working on hobby projects. It allows me to experiment with new technologies and ideas outside of my professional work. It's a creative outlet for me and keeps me motivated to continue learning and growing as a developer. I have probably started more projects than I have finished, but that's all part of the fun!
            </p>
          </div>
        </div>
      </div>
    </>
  );
}